import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { initGA, trackPageView } from './services/analytics';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Import components
import Header from './components/Header';
import { Footer } from './components/Footer';
import MaintenanceHero from './components/MaintenanceHero';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ControlForge from './pages/ControlForge';

// Import Mantine styles
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

const theme = createTheme({
  primaryColor: 'purple',
  colors: {
    purple: ['#F3E8FF', '#E9D5FF', '#D8B4FE', '#C084FC', '#A855F7', '#9333EA', '#6B46C1', '#553C9A', '#44337A', '#322659'],
    blue: ['#EFF6FF', '#DBEAFE', '#BFDBFE', '#93C5FD', '#60A5FA', '#3B82F6', '#2563EB', '#1D4ED8', '#1E40AF', '#1E3A8A'],
  },
  fontFamily: 'Inter, sans-serif',
  headings: {
    fontFamily: 'Inter, sans-serif',
  },
});

// Analytics wrapper component
function AnalyticsWrapper() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  return (
    <Router>
      <MantineProvider theme={theme}>
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          scriptProps={{
            async: true,
            defer: true,
            appendTo: 'head',
          }}
        >
          <Notifications position="top-right" zIndex={2000} />
          <AnalyticsWrapper />
        
        {isMaintenanceMode ? (
          <MaintenanceHero />
        ) : (
          <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <main style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/products/control-forge" element={<ControlForge />} />
                <Route path="/maintenance" element={<MaintenanceHero />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        )}
        </GoogleReCaptchaProvider>
      </MantineProvider>
    </Router>
  );
}

export default App;
